import { ISidebarMenuItem } from '@src/molecules/SidebarMenu/models';

export const filterMenuItems = (items: ISidebarMenuItem[], query: string) => {
  if (!query) return items;

  return items.reduce<ISidebarMenuItem[]>((result, item) => {
    const nested = item.nested ? filterMenuItems(item.nested, query) : undefined;

    if (Array.isArray(nested) && nested.length > 0) {
      result.push({ ...item, nested });

      return result;
    }

    const searchTerm = (typeof item.name === 'string' && item.name) || item.searchName;

    if (searchTerm) {
      const regex = RegExp(query, 'gi');
      const matchResult = searchTerm.match(regex);

      if (matchResult && matchResult.length > 0) {
        result.push(item);
      }
    }

    return result;
  }, []);
};
